import { render, staticRenderFns } from "./RegisteredPlayers.vue?vue&type=template&id=b52c25e4&"
import script from "./RegisteredPlayers.vue?vue&type=script&lang=ts&"
export * from "./RegisteredPlayers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports